import { CreateChargeOptions, useCreateCharge } from 'APP/Hooks/useCreateCharge'
import { CHECKOUT_TYPE, CheckoutContext, FeePolicy } from 'APP/Components/Checkout'
import { logger } from 'APP/Lib/Datadog'
import { showToast } from 'APP/Converse/Toast/helpers'
import I18n from 'APP/I18n'

interface HandleCheckoutConfirmParams {
  feePolicy: FeePolicy
  episodeId: string
  checkoutType: CHECKOUT_TYPE
  checkoutContext: CheckoutContext<CHECKOUT_TYPE>
  createCharge: ReturnType<typeof useCreateCharge>['createCharge']
  sendAnswer: (reply: { payload: unknown; display: string }) => void
}

// TODO: Ideally the call to create a charge is done all within the Components/Checkout/index.tsx component, See https://dialoguemd.atlassian.net/browse/CLI-875
export const handleCheckoutConfirm = async (params: HandleCheckoutConfirmParams): Promise<void> => {
  const { feePolicy, episodeId, checkoutType, checkoutContext, createCharge, sendAnswer } = params

  const chargeData: CreateChargeOptions = {
    amount: feePolicy.encounterFeeAmount,
    description: '',
    meta: {
      episode_id: episodeId,
      reason_for_charge: 'service_rendered',
    },
  }

  if (checkoutType === CHECKOUT_TYPE.SERVICE) {
    const context = checkoutContext as CheckoutContext<CHECKOUT_TYPE.SERVICE>

    chargeData.description = `${context.serviceName} Service`

    if (chargeData.meta) chargeData.meta.service = context.serviceSlug

    chargeData.capture = true
  }

  try {
    const charge = await createCharge(chargeData)
    const display = I18n.t('CheckoutScreen.completed')
    const payload = { reference: charge.id }

    sendAnswer({
      payload,
      display,
    })
  } catch (error) {
    logger.error(`Chat Checkout charge failed: ${String(error)}`)
    showToast({
      variant: 'error',
      title: I18n.t('Checkout.chargeErrorTitle'),
      description: I18n.t('Checkout.chargeErrorDescription'),
    })
    throw error
  }
}
